module.exports = __webpack_public_path__ + "static/media/logo1.7193f2b0.png";